var parent = require('../../../es/array/virtual/for-each');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/array/virtual/for-each.js
// module id = 1107
// module chunks = 0